// libraries
import { useEffect, useState } from "react"
import { BarChart } from "@mui/x-charts"
import Skeleton from "react-loading-skeleton"
import moment from "moment"

// helpers
import Api from "../../../../_helpers/Api"

// providers
import { useAuthDataContext } from "@/_providers/Auth"
import { trans } from "@/_providers/Translation"

export default function SentMessagesChart() {
  const { lang } = useAuthDataContext()

  const [chartData, setChartData] = useState([])
  const [customers, setCustomers] = useState([])
  const [filters, setFilters] = useState({ customer_id: "" })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadData()
  }, [filters])

  const loadData = () => {
    setLoading(true)

    Api.get(`dashboard/sent-messages?customer_id=${filters.customer_id}`)
      .then((res) => {
        const dailyBreakdown = (res.data?.daily_breakdown || []).map(
          (item) => ({
            ...item,
            day_name_translated: moment(item.date, "YYYY-MM-DD")
              .locale(lang())
              .format("ddd"),
          }),
        )
        setChartData(dailyBreakdown)
        setCustomers(res.data?.customers || [])
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  function getIfAnyMessages() {
    return chartData.some(
      (item) =>
        item.sms > 0 || item.viber > 0 || item.whatsapp > 0 || item.email > 0,
    )
  }

  return (
    <div className="messages-chart">
      <div className="head">
        <h3>{trans("tabs.sendMessages")}</h3>
        <select name="customer_id" onChange={handleFilterChange}>
          <option value="">{trans("random.allCustomers")}</option>
          {customers.map((c) => (
            <option key={c.id} value={c.id}>
              {c.full_name}
            </option>
          ))}
        </select>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !getIfAnyMessages() ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <BarChart
          dataset={chartData}
          xAxis={[
            {
              scaleType: "band",
              dataKey: "day_name_translated",
            },
          ]}
          series={[
            {
              dataKey: "sms",
              label: "SMS",
              color: "#4A3AFF",
            },
            {
              dataKey: "viber",
              label: "Viber",
              color: "#C893FD",
            },
            {
              dataKey: "whatsapp",
              label: "WhatsApp",
              color: "#35B084",
            },
            {
              dataKey: "email",
              label: "Email",
              color: "#6CE0FF",
            },
          ]}
          height={300}
          margin={{
            right: 0,
          }}
          slotProps={{
            legend: { hidden: true },
          }}
          borderRadius={4}
        />
      )}
    </div>
  )
}
